import { render, staticRenderFns } from "./GeolocationQuestion.vue?vue&type=template&id=684c6dca&scoped=true"
import script from "./GeolocationQuestion.vue?vue&type=script&lang=js"
export * from "./GeolocationQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684c6dca",
  null
  
)

export default component.exports